<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc"></a>
<h2 class="chaptertitle1">CONTENTS</h2>
<p class="toc-chapter" id="toc_p1">
<a href="#/illustration">Illustrations</a>
</p>
<p class="toc-part" id="toc_p2">
<a href="#/part1">PART 1: THE MORNING OF THE MONKEY</a>
</p>
<p class="toc-part" id="toc_p4">
<span href="#/part2" title="Link target outside of Sample">PART 2: THE NIGHT OF THE TIGER</span>
</p>
<p class="toc-chapter" id="toc_p6">
<span href="#/postscript" title="Link target outside of Sample">POSTSCRIPT</span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5cd4f5fe